import cookies from 'js-cookie'

import ThirdPartyTracking from '@thebeansgroup/third_party_tracking'

import {
  FACEBOOK_CONVERSION_API_SCHEMA,
  FACEBOOK_ID,
  FACEBOOK_CLICK_ID,
  SNAPCHAT_CONVERSION_API_SCHEMA,
  SNAPCHAT_USER_ID_COOKIE_NAME,
  TIKTOK_CONVERSION_API_SCHEMA,
  TIKTOK_ID,
  TIKTOK_CLICK_ID
} from '@constants/third_party_tracking'

export const hashedEmail = (email) =>
  ThirdPartyTracking.getNormalisedHashedString(email)

export const getFacebookConversionApiEvent = (facebookEventUid, email) => {
  return {
    schema: FACEBOOK_CONVERSION_API_SCHEMA,
    data: {
      facebook_event_uid: facebookEventUid || '',
      fbp: cookies.get(FACEBOOK_ID) || null,
      fbc: cookies.get(FACEBOOK_CLICK_ID) || null,
      hashed_email: hashedEmail(email)
    }
  }
}

export const getSnapchatConversionApiEvent = (dedupeId, email) => {
  return {
    schema: SNAPCHAT_CONVERSION_API_SCHEMA,
    data: {
      client_dedup_id: dedupeId || '',
      hashed_email: hashedEmail(email),
      uuid_c1: cookies.get(SNAPCHAT_USER_ID_COOKIE_NAME) || null
    }
  }
}

export const getTikTokConversionApiEvent = (dedupeId, email, contentId) => {
  return {
    schema: TIKTOK_CONVERSION_API_SCHEMA,
    data: {
      tiktok_event_id: dedupeId || '',
      ttp: cookies.get(TIKTOK_ID) || null,
      ttclid: cookies.get(TIKTOK_CLICK_ID) || null,
      hashed_email: hashedEmail(email),
      content_id: contentId || ''
    }
  }
}

export const getConversionApiSnowplowContexts = (
  dedupeId,
  email,
  contentId
) => [
  getFacebookConversionApiEvent(dedupeId, email),
  getSnapchatConversionApiEvent(dedupeId, email),
  getTikTokConversionApiEvent(dedupeId, email, contentId)
]

export const getThirdPartyConfig = () => {
  const trackingDisabled = !process.env.NEXT_PUBLIC_ENABLED_THIRD_PARTY_TRACKING

  return {
    snapchatTracker: {
      disabled:
        trackingDisabled || !process.env.NEXT_PUBLIC_SNAPCHAT_TRACKING_ENABLED,
      id: process.env.NEXT_PUBLIC_SNAPCHAT_TRACKING_ID
    },
    facebookTracker: {
      disabled:
        trackingDisabled ||
        !process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_TRACKING_ENABLED,
      id: process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID
    },
    googleTracker: {
      disabled:
        trackingDisabled || !process.env.NEXT_PUBLIC_GOOGLE_TRACKING_ENABLED,
      id: process.env.NEXT_PUBLIC_GOOGLE_ADS_TRACKING_ID
    },
    twitterTracker: {
      disabled:
        trackingDisabled || !process.env.NEXT_PUBLIC_TWITTER_TRACKING_ENABLED,
      id: process.env.NEXT_PUBLIC_TWITTER_TRACKING_ID
    },
    contentsquareTracker: {
      disabled:
        trackingDisabled ||
        !process.env.NEXT_PUBLIC_CONTENTSQUARE_TRACKING_ENABLED,
      id: process.env.NEXT_PUBLIC_CONTENTSQUARE_TAG_ID
    },
    tiktokTracker: {
      disabled:
        trackingDisabled || !process.env.NEXT_PUBLIC_TIKTOK_TRACKING_ENABLED,
      id: process.env.NEXT_PUBLIC_TIKTOK_TRACKING_ID
    },
    taboolaTracker: {
      disabled:
        trackingDisabled || !process.env.NEXT_PUBLIC_TABOOLA_TRACKING_ENABLED,
      id: process.env.NEXT_PUBLIC_TABOOLA_TRACKING_ID
    }
  }
}
